import { ReactNode } from 'react';
import ReactDOM from 'react-dom';

export enum MIP_CREATE_PORTALS {
	SECTION_HEADER = '#mip-create-section-portal',
}

export const renderMIPCreateSectionHeaderPortal = (children: ReactNode) => {
	const portalElement = document.getElementById(MIP_CREATE_PORTALS.SECTION_HEADER);
	if (!portalElement) {
		return children;
	}
	return ReactDOM.createPortal(children, portalElement);
};
